import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';

type CommandMenuItemProps = ComponentPropsWithoutRef<typeof Command.Item>;

export const CommandMenuItem = forwardRef<ElementRef<typeof Command.Item>, CommandMenuItemProps>(
  ({ className, ...props }, ref) => (
    <Command.Item
      ref={ref}
      className={cn(
        "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none data-[disabled=true]:pointer-events-none data-[selected='true']:bg-accent data-[selected=true]:text-accent-foreground data-[disabled=true]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
        className,
      )}
      {...props}
    />
  ),
);

CommandMenuItem.displayName = Command.Item.displayName;
